import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../pages/Sidebar";

export default function AppLayout() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen">
      <Sidebar path={location.pathname} />
      <main className="flex-1 ml-[300px] p-6 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
